import { useCallback } from 'react';
import { useNotifier } from '@provider/notifier';
import { useDeleteRevisionMutation } from '../api/mutation.delete.js';
import { useActiveRevision } from '../hook.active-revision.js';
import { makeDeleteRevisionConfirmConfig } from '../modals/delete.js';
import { courseRevisionsStore } from '../store.js';

function useDeleteRevision(courseId) {
  const deleteMutation = useDeleteRevisionMutation();
  const activeRevision = useActiveRevision(courseId);
  const notifier = useNotifier();
  return useCallback(async revision => {
    if ((await notifier.confirm(makeDeleteRevisionConfirmConfig(revision))) !== "ok") {
      return;
    }
    deleteMutation.mutate(revision);
    if (activeRevision?.id === revision.id) {
      courseRevisionsStore.dispatch(courseRevisionsStore.actions.toggleEditMode({
        state: false
      }));
    }
  }, [activeRevision?.id, deleteMutation, notifier]);
}

export { useDeleteRevision };
//# sourceMappingURL=delete.js.map
